import { Component } from 'react';
import styled from 'styled-components';

interface IProps {
  readonly tabType: 'text' | 'block';
  readonly children: React.ReactNode;
}

const List = styled.ul<{ $tabType: IProps['tabType'] }>`
  display: flex;

  ${({ $tabType }) =>
    $tabType === 'text'
      ? `
  /* テキストタイプのタブ */
  padding: 12px;
  `
      : ''}
  ${({ $tabType }) =>
    $tabType === 'block'
      ? `
  /* ブロックタイプのタブ */
  position: relative;
  bottom: -1px;
  margin-left: 15px;
  `
      : ''}
  & + & {
    /* タブが2段になる場合：textタブのboder-bottomを隠す */
    margin-top: -1px;
  }
`;

export default class TabList extends Component<IProps> {
  /**
   *
   */
  public render() {
    return <List $tabType={this.props.tabType}>{this.props.children}</List>;
  }
}
